import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import { UcThemeContext } from '../../lib/UcThemeProvider';
import { ApiClient } from '../../lib/ApiClient';
import { useRegisterConfirmPassword } from '../auth/useRegisterConfirmEmail';
import "./SignOut.scss";

const apiClient = new ApiClient();

export default function Register(props) {
    // eslint-disable-next-line no-unused-vars
    const [themeState, themeDispatch] = React.useContext(UcThemeContext);
    const params = new URLSearchParams(window.location.search);
    // TODO: XSS protection
    const userId = params.get("userId");
    const code = params.get("code");

    const confirmPassword = useRegisterConfirmPassword(userId, code, apiClient);

    return (
        <>
            <Box
                sx={{
                    marginTop: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                { confirmPassword.isLoading &&
                    <Box sx={{ mt: 5, textAlign: 'center' }}>
                        <CircularProgress color="primary" size={50}  aria-label="Loading..." title="Loading..." />
                    </Box>
                }
                { !confirmPassword.isLoading &&
                    <>
                        { confirmPassword.isError &&
                            <>
                                <Alert severity="error">
                                    {confirmPassword.result}
                                </Alert>
                            </>
                        }
                          { !confirmPassword.isError &&
                            <>
                                <Alert severity="success">
                                    {confirmPassword.result}
                                </Alert>
                            </>
                        }
                    </>
                }
            </Box>
        </>
    );
}